import { Box, Group, Skeleton, Stack } from '@mantine/core';

interface ListRowSkeletonProps {
  /** Number of placeholder rows to render. */
  count?: number;
}

/**
 * Placeholder rows matching the app's list-row layout (title line + a
 * secondary metadata line, separated by hairline borders) — used while
 * lists are loading instead of a full-page spinner, so pages don't jump
 * from "blank + spinner" to "full content" with a visible layout shift.
 */
export const ListRowSkeleton = ({ count = 5 }: ListRowSkeletonProps) => (
  <Stack gap={0}>
    {Array.from({ length: count }, (_, index) => (
      <Box
        // biome-ignore lint/suspicious/noArrayIndexKey: static placeholder list, order never changes
        key={index}
        px="md"
        py="md"
        style={{ borderBottom: '1px solid var(--mantine-color-ink-3)' }}
      >
        <Group justify="space-between" wrap="nowrap">
          <Skeleton height={16} radius={0} width="55%" />
          <Skeleton height={16} radius={0} width={64} />
        </Group>
        <Group gap="xs" mt={8}>
          <Skeleton height={10} radius={0} width={90} />
          <Skeleton height={10} radius={0} width={70} />
        </Group>
      </Box>
    ))}
  </Stack>
);
